import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CrewPerDiemNotesAmountDetails } from './../../@shared/models/per-diem.modal';
import { ForemanService } from 'src/app/other shared services/foreman.service';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { API_URL_UTIL, BaseComponent } from 'src/app/@core/utils';
import { getFormattedDate } from 'src/app/@core/utils/date-format.utils';
import * as moment from 'moment';
import { takeUntil } from 'rxjs';
import { ApiResponse,JobType,OtherJobDetailsCrew, PerDiemCrueMember, PerDiemData, PerDiemDataApiResponse  } from 'src/app/@shared/models';
import { EventTask } from 'src/app/@shared/models/user.modal';
import { SidebarModalService } from 'src/app/@shared/services/sidebar-modal.service';
import { PerDiemService } from './per-diem.service';
import { StatusService } from 'src/app/@shared/services/status.service';
import { ToasterService } from 'src/app/@core/services';
import { UserDataService } from 'src/app/@shared/services/user-data.service';
import { HttpStatus } from 'src/app/@shared/models/add-employee.modal';

@Component({
  selector: 'app-per-diem-sidebar',
  templateUrl: './per-diem-sidebar.component.html',
  styleUrls: ['./per-diem-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PerDiemSidebarComponent extends BaseComponent implements OnInit {
  jobScheduleCrewPerDiemID!:string
  perDiemForm!: FormGroup;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  products!: Array<object>;
  modalRef!:BsModalRef;
  logInUser!: string;
  crewPerDiemNotesAmountDetails: Array<CrewPerDiemNotesAmountDetails> = [];
  userSelectedEvent!: EventTask;
  userSelectedJobId!: string;
  selectedDate!: Date;
  otherJobDetailsCrew!: Array<OtherJobDetailsCrew>;
  crewDetail!: PerDiemCrueMember;
  perDiemApiResponse!: PerDiemDataApiResponse
  @Input() currentList!: PerDiemData
  constructor(
    private readonly perDiemService: PerDiemService,
    private readonly userDataService: UserDataService,
    private readonly formBuilder: FormBuilder,
    private readonly toastrService: ToasterService,
    private readonly sidebarModalService: SidebarModalService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly foremanService: ForemanService,
    private readonly statusService: StatusService,
    private readonly modalService:BsModalService
  ) {
    super();
  }


  ngOnInit(): void {
    this.genratePerDiemForm();
    this.getCurrentDetails();
    this.products = [{}];
  }

  getCrewPerDiemDetails(): void {
    this.perDiemService.getCrewPerDiemDetails(this.userSelectedJobId, getFormattedDate(this.selectedDate), this.currentList.employeeId, 1, 5).subscribe({
      next: (perDiemApiResponse: PerDiemDataApiResponse) => {
        this.perDiemApiResponse = perDiemApiResponse;
        this.crewDetail = perDiemApiResponse.data.crewDetails;
        this.otherJobDetailsCrew = this.perDiemApiResponse.data.otherJobDetailsCrew;
        this.crewPerDiemNotesAmountDetails = this.perDiemApiResponse.data.crewPerDiemNotesAmountDetails;
      }
    });
  }

  getCurrentDetails(): void {
    this.userSelectedJobId = this.activatedRoute.snapshot.queryParams.jobScheduleID;
    if (this.userSelectedJobId) {
      this.getJobScheduleDetails(this.userSelectedJobId);
    }
    const date = this.activatedRoute.snapshot.queryParams.date;
    const momentDate = moment(date).toDate();
    this.selectedDate = momentDate;
    if (this.userSelectedJobId && this.selectedDate) {
      this.getCrewPerDiemDetails();
    }
  }

  saveChanges(): void {
    this.perDiemForm.markAllAsTouched();
    if (this.perDiemForm.valid) {
      this.perDiemService.updateCrewPerDiemDetails(this.userSelectedJobId, this.crewDetail.employeeId, this.userDataService.getLoginUser(), this.perDiemForm.value.PerDiemAmount, this.perDiemForm.value.PerDiemRemarks).pipe(takeUntil(this.destroy$)).subscribe({
        next: (update: HttpStatus) => {
          this.toastrService.success(update.message);
          this.closeModal();
        },
      })
    }
  }

  genratePerDiemForm(): void {
    this.perDiemForm = this.formBuilder.group({
      PerDiemAmount: ['', [Validators.required, Validators.pattern(this.constants.validation.decimal)]],
      PerDiemRemarks: ['']
    })

  }

  closeModal(): void {
    this.onClose.emit(true);
    this.sidebarModalService.hideModal();
  }

  getJobScheduleDetails(jobScheduleId: string): void {
    this.foremanService.get<ApiResponse<EventTask>>(jobScheduleId, API_URL_UTIL.foreman.jobSchedule).pipe(takeUntil(this.destroy$)).subscribe({
      next: (job: JobType) => {
        this.statusService.updateStatus(job.data.jobCompleted);
        this.userSelectedEvent = job.data;
      }
    })
  }

  deletedPerDiemPopup(deletedPerDiemPopup: TemplateRef<unknown>,jobScheduleCrewPerDiemID:string): void {
    this.modalService.show(deletedPerDiemPopup);
    this.jobScheduleCrewPerDiemID=jobScheduleCrewPerDiemID;
  }

  deletedPerDiemApi(event: boolean): void {
    if(event){
    this.perDiemService.deletedPerDiemApi(this.jobScheduleCrewPerDiemID,this.userDataService.getLoginUser()).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data:any)=>{
        this.toastrService.success(data.message);
        this.closeModal();
      }
    });
  }
  }


}
